import type { OzonetelInitializeEventPayload, OzonetelStartCallPayload } from './sdk';
import type { OztPhoneNumberPayload, OztSetModePayload } from './shared';

export const OZT_METHOD_TYPES = {
  initialize: 'ozt_initialize',
  startCall: 'ozt_startCall',
  endCall: 'ozt_endCall',
  hold: 'ozt_hold',
  unhold: 'ozt_unhold',
  mute: 'ozt_mute',
  unmute: 'ozt_unmute',
  muteAgent: 'ozt_muteAgent',
  unmuteAgent: 'ozt_unmuteAgent',
  setMode: 'ozt_setMode',
  logout: 'ozt_logout',
  getCallData: 'ozt_getCallData',
  releaseAgent: 'ozt_releaseAgent',
  getCallRecording: 'ozt_getCallRecording',
} as const;

export type OztMethodType = (typeof OZT_METHOD_TYPES)[keyof typeof OZT_METHOD_TYPES];

export interface OztMethodPayloadMap {
  [OZT_METHOD_TYPES.initialize]: OzonetelInitializeEventPayload;
  [OZT_METHOD_TYPES.startCall]: OzonetelStartCallPayload;
  [OZT_METHOD_TYPES.endCall]: undefined;
  [OZT_METHOD_TYPES.hold]: OztPhoneNumberPayload | undefined;
  [OZT_METHOD_TYPES.unhold]: OztPhoneNumberPayload | undefined;
  [OZT_METHOD_TYPES.mute]: undefined;
  [OZT_METHOD_TYPES.unmute]: undefined;
  [OZT_METHOD_TYPES.muteAgent]: undefined;
  [OZT_METHOD_TYPES.unmuteAgent]: undefined;
  [OZT_METHOD_TYPES.setMode]: OztSetModePayload;
  [OZT_METHOD_TYPES.logout]: undefined;
  [OZT_METHOD_TYPES.getCallData]: undefined;
  [OZT_METHOD_TYPES.releaseAgent]: undefined;
  [OZT_METHOD_TYPES.getCallRecording]: undefined;
}

export type OztMethod = {
  [K in OztMethodType]: { eventType: K; eventPayload: OztMethodPayloadMap[K] };
}[OztMethodType];

export const isOztMethod = (eventType?: string): eventType is OztMethodType =>
  Object.values(OZT_METHOD_TYPES).includes(eventType as OztMethodType);
